module.exports = ".select-column {\r\n    text-align: center;\r\n}\r\n\r\n.row-expand-button {\r\n    cursor: pointer;\r\n    text-align: center;\r\n}\r\n\r\n.clickable {\r\n    cursor: pointer;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/data-table/components/row.css
// module id = ./src/app/shared/data-table/components/row.css
// module chunks = main